import { DatePicker, LocalizationProvider } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { TextField } from '@mui/material';
import koLocale from 'date-fns/locale/ko';
import React from 'react';
import { convToDateFromYearMonth } from '../util/date';

function CommonSettlementDatePicker({
  value,
  onChange,
}: {
  value?: string;
  onChange: (dateValue: Date | null | undefined) => void;
}) {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} locale={koLocale}>
      <DatePicker
        InputProps={{ style: { height: 41 } }}
        disableFuture
        label='년/월'
        openTo='month'
        inputFormat='yyyy년 MM월'
        views={['year', 'month']}
        value={convToDateFromYearMonth(value) || new Date()}
        onChange={onChange}
        renderInput={(params: any) => <TextField {...params} />}
      />
    </LocalizationProvider>
  );
}

export default CommonSettlementDatePicker;
